import { ContentTypes } from "../brandVariables.types";

export const tclttContent: ContentTypes = {
  generalHeadline: "CS2 Time Trial",
  generalHeadlineAlt: "Set the fastest time!",
  subHeadline: "Lorem ipsum...",
  overviewHeadline: "",
  endscreenHeadline: "Thank you and congratulations to our winners",
};
